import { render, staticRenderFns } from "./upgrade_test_edit.vue?vue&type=template&id=32599078&scoped=true&"
import script from "./upgrade_test_edit.vue?vue&type=script&lang=js&"
export * from "./upgrade_test_edit.vue?vue&type=script&lang=js&"
import style0 from "./upgrade_test_edit.vue?vue&type=style&index=0&id=32599078&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32599078",
  null
  
)

export default component.exports